<header>
    <app-header headerName="Village Staff"></app-header>
  </header>

  <div class="outer-conatiner"> 
    <div class="village-staff-container">
      <app-page-title pageTitle='Village of Volo Overnight Parking'></app-page-title>
       <section class="container-wrapper search-section">
        <mat-tab-group (selectedIndexChange)="selectTab($event)">
          <mat-tab label="Add Permits" > 
           <app-add-permit *ngIf="selectedTab == 0 || selectedTab == undefined"></app-add-permit>
             </mat-tab>
             <mat-tab label="Permits">
              <app-permit *ngIf="selectedTab == 1"></app-permit>
             </mat-tab>
            <mat-tab label="Waivers" > 
              <p style="position: absolute;" class="sub-form-title no-margin">Search Result</p>
              <app-waviers *ngIf="selectedTab == 2"></app-waviers>
               </mat-tab>
            <mat-tab label="Enforcement">
               <app-enforcement *ngIf="selectedTab == 3"></app-enforcement> </mat-tab>
          </mat-tab-group>
       </section>
    </div>
 </div>
 